import React from 'react';
import Helmet from 'react-helmet';
import * as _ from 'lodash';
import moment from 'moment';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import ReactDropDownCalender from '../components/ReactDropDownCalender';
import { CompanyBranchDropdown } from '../components/dropdowns/single/CompanyBranch';
import { WorkSummariesService } from '../services/WorkSummaries';
import {
  HEADER_CONSTANTS,
  REQUEST_PARAMS,
  DATE_RANGE_TYPE,
  USER_ROLES,
  API_FLAG,
} from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import LocalStorageService from '../services/utilities/LocalStorageService';
import { isTargetRoleId } from '../utilities/roleUtility';
import { MasterPageHeader } from '../components/PageHeader';

const DEFAULT_SEARCH_PARAM = {
  date_range: DATE_RANGE_TYPE.term.id, // 期間設定タイプ
  work_date_from: moment().format('YYYY/MM/DD'), // 期間(From)
  work_date_to: moment().format('YYYY/MM/DD'), // 期間(To)
  work_date: moment().format('YYYY/MM/DD'), // 日付
  company_branch_id: '', // 支店ID
}

/**
 * @description 稼働情報画面
 */
export class FieldWorkSummaries extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      roleId: LocalStorageService.getRoleId(),
      total: 0, // 稼働情報取得件数
      isLoaded: false, // ページング用ロードフラグ
      isOpened: false, // 検索フォーム開閉フラグ
      isFetch: false, // 再読み込みフラグ
      isLoading: true, // ロード中フラグ
      workSummaries: [], // 取得稼働情報
      searchParam: _.cloneDeep(DEFAULT_SEARCH_PARAM), // 検索条件
      currentSearchParam: _.cloneDeep(DEFAULT_SEARCH_PARAM),
    };

    this.my_branch = API_FLAG.Off;
    this.searchButtonRef = React.createRef(); // 検索ボタン要素
    this.inputSearchParam = this.inputSearchParam.bind(this); // 検索条件入力
    this.searchExecution = this.searchExecution.bind(this); // 検索実行
    this.clearFlag = false;
  }

  componentWillMount() {
    if (
      isTargetRoleId([USER_ROLES.branch, USER_ROLES.manager], this.state.roleId)
    ) {
      this.my_branch = API_FLAG.On;
    } else {
      this.my_branch = API_FLAG.Off;
    }
    this.setWorkSummaries(() => {});
  }

  componentDidUpdate() {
    if (this.clearFlag === true) {
      this.clearFlag = false;
    }
    if (this.state.isFetch) {
      this.setWorkSummaries(() => {});
      this.setState({ isFetch: false });
    }
  }

  /**
   * @description 稼働情報取得
   * @param {*} notify
   */
  setWorkSummaries(notify) {
    if (this.state.isLoaded) {
      notify();
      this.setState({ isLoading: false });
      return;
    }

    const params = this.getApiParams();
    params.limit = REQUEST_PARAMS.parentLimit;
    params.offset = _.size(this.state.workSummaries);

    WorkSummariesService.fieldList(params).then(resp => {
      this.setState({ total: resp.data.total });
      if (resp.result) {
        const getWorkSummaries = resp.data.entities.work_summaries;
        if (_.isEmpty(getWorkSummaries)) {
          this.setState({ isLoaded: true });
        } else {
          let workSummaries = notify ? this.state.workSummaries : [];
          delete params.limit;
          delete params.offset;
          _.each(getWorkSummaries, getWorkSummary => {
            this.setDayworker(workSummaries.length, getWorkSummary.id, params);
            params.field_id = getWorkSummary.id;
            this.setPartner(workSummaries.length, params);
            workSummaries.push(getWorkSummary);
          });
          this.setState({
            workSummaries,
            isLoaded: false,
          });
        }
      }
      this.searchButtonRef.current.disabled = false;
      this.setState({ isLoading: false });
      if (notify) {
        notify();
        return;
      }
    });
  }

  /**
   * @description API用パラメータ取得
   */
  getApiParams() {
    const apiParams = {};
    const searchParam = this.state.currentSearchParam;

    if (searchParam.date_range === DATE_RANGE_TYPE.term.id) {
      apiParams.work_date_from = searchParam.work_date_from;
      apiParams.work_date_to = searchParam.work_date_to;
    } else {
      apiParams.work_date = searchParam.work_date;
    }
    if (searchParam.company_branch_id !== '') {
      apiParams.company_branch_id = searchParam.company_branch_id;
    }

    return apiParams;
  }

  /**
   * @description 人工情報取得
   * @param {int} index 要素数
   * @param {int} field_id 現場ID
   * @param {object} param apiパラメータ
   */
  setDayworker = (index, field_id, param) => {
    param.field_id = field_id;
    WorkSummariesService.workerList(param).then(resp => {
      if (resp.result) {
        const workSummaries = this.state.workSummaries;
        workSummaries[index].worker = resp.data.entities.work_summaries;
        this.setState({ workSummaries });
      }
    });
  };

  /**
   * @description 詳細稼働情報取得
   * @param {int} index 要素数
   * @param {object} param apiパラメータ
   */
  setPartner = (index, param) => {
    WorkSummariesService.partnerList(param).then(resp => {
      if (resp.result) {
        const workSummaries = this.state.workSummaries;
        workSummaries[index].partner = resp.data.entities.work_summaries;
        this.setState({ workSummaries });
      }
    });
  };

  /**
   * @description 検索フォーム開閉設定
   */
  handleSearchFormShow = () => {
    this.setState({ isOpened: !this.state.isOpened });
  };

  /**
   * @description 検索条件入力
   * @param {string} name フォーム名
   * @param {string} value 入力値
   */
  inputSearchParam = (name, value) => {
    const searchParam = { ...this.state.searchParam };
    searchParam[name] = value;
    this.setState({ searchParam });
  };

  /**
   * @description 検索実行
   */
  searchExecution() {
    this.searchButtonRef.current.disabled = true;
    this.setState({
      isLoaded: false,
      workSummaries: [],
      isFetch: true,
      isLoading: true,
      currentSearchParam: _.cloneDeep(this.state.searchParam),
    });
  }

  /**
   * @description 検索条件クリア
   */
  onClearSearchParam = () => {
    this.clearFlag = true;
    this.setState({
      isLoaded: false,
      isFetch: true,
      isLoading: true,
      workSummaries: [],
      searchParam: _.cloneDeep(DEFAULT_SEARCH_PARAM),
      currentSearchParam: _.cloneDeep(DEFAULT_SEARCH_PARAM),
    });
  };

  /**
   * @description 検索フォーム
   */
  searchForm = () => {
    const { searchParam } = this.state;

    return (
      <div className='search-form__body set-width-dropdown'>
        <div className='form form--search-form'>
          <div className='form__group flex-wrap'>
            <div className='form-element'>
              <div className='form-element__label'>
                <span className='label'>期間</span>
              </div>
              <div className='form-element__element'>
                <div className='form-element-horizontal'>
                  <div className='form-element-horizontal__item'>期間</div>
                  <div className='form-element-horizontal__item'>
                    <label htmlFor='date_range-1' className='radio'>
                      <input
                        type='radio'
                        id='date_range-1'
                        name='date_range'
                        checked={
                          searchParam.date_range === DATE_RANGE_TYPE.term.id
                        }
                        onChange={e =>
                          this.inputSearchParam(
                            e.target.name,
                            DATE_RANGE_TYPE.term.id
                          )
                        }
                      />
                      <i className='i-circle i-3x' aria-hidden='true' />
                    </label>
                  </div>
                  <div className='form-element' style={{ padding: 0 }}>
                    <ReactDropDownCalender
                      onChange={date =>
                        this.inputSearchParam('work_date_from', date)
                      }
                      value={searchParam.work_date_from}
                      format={'YYYY/MM/DD'}
                    />
                  </div>
                  <div className='form-element' style={{ padding: 0 }}>
                    <p>-</p>
                  </div>
                  <div className='form-element' style={{ padding: 0 }}>
                    <ReactDropDownCalender
                      onChange={date =>
                        this.inputSearchParam('work_date_to', date)
                      }
                      value={searchParam.work_date_to}
                      format={'YYYY/MM/DD'}
                    />
                  </div>
                </div>
                <div className='form-element-horizontal'>
                  <div className='form-element-horizontal__item'>日付</div>
                  <div className='form-element-horizontal__item'>
                    <label htmlFor='date_range-2' className='radio'>
                      <input
                        type='radio'
                        id='date_range-2'
                        name='date_range'
                        checked={
                          searchParam.date_range === DATE_RANGE_TYPE.date.id
                        }
                        onChange={e =>
                          this.inputSearchParam(
                            e.target.name,
                            DATE_RANGE_TYPE.date.id
                          )
                        }
                      />
                      <i className='i-circle i-3x' aria-hidden='true' />
                    </label>
                  </div>
                  <div className='form-element' style={{ padding: 0 }}>
                    <ReactDropDownCalender
                      onChange={date =>
                        this.inputSearchParam('work_date', date)
                      }
                      value={searchParam.work_date}
                      format={'YYYY/MM/DD'}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className='form-element  --col-xs-12 --col-md-3 --col-lg-2 --col-xl-2'>
              <div className='form-element__label'>
                <span className='label'>支店名</span>
              </div>
              <div className='form-element__element'>
                <CompanyBranchDropdown
                  my_branch={this.my_branch}
                  value={searchParam.company_branch_id}
                  set={this.inputSearchParam}
                  setkey='company_branch_id'
                  clearFlag={this.clearFlag}
                  isOptional={true}
                />
              </div>
            </div>
            <button
              className='btn--sm--stay'
              style={{ position: 'relative', top: '35px' }}
              onClick={this.searchExecution}
              ref={this.searchButtonRef}
            >
              検索
            </button>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const { total, isOpened, workSummaries } = this.state;

    return (
      <div className='master-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 稼働状況</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title={'稼働状況'}
            onClose={() => _masterSlideLoader.close()}
          />
          <div id='infinityscroll-target' className='master-slide-view__table'>
            <div className='master-slide-view__searchform'>
              <div className='search-form'>
                <div className='search-form__header'>
                  <div className='search-form__title'>
                    検索条件（検索結果
                    <span className='bold'>{total}</span>件)
                  </div>
                  <button
                    id='setting-search-accordion-toggle'
                    className={
                      isOpened ? 'accordion__btn show' : 'accordion__btn'
                    }
                    onClick={e => this.handleSearchFormShow(e)}
                  />
                  <button
                    className='btn-text--sm'
                    onClick={this.onClearSearchParam}
                  >
                    検索条件クリア
                  </button>
                </div>
                <div
                  id='setting-search-accordion'
                  className={isOpened ? 'accordion show' : 'accordion'}
                >
                  {this.searchForm()}
                </div>
              </div>
            </div>
            <div id='infinityscroll-target' className='master-slide-view__body'>
              <table className='table'>
                <thead className='table__header'>
                  <tr className='table__label'>
                    <td className='value-table value-table--table__label'>
                      <div className='value-table__label'>現場名</div>
                    </td>
                    <td className='value-table value-table--table__label'>
                      <div className='value-table__label'>予定人工</div>
                    </td>
                    <td className='value-table value-table--table__label'>
                      <div className='value-table__label'>実績人工</div>
                    </td>
                    <td className='value-table value-table--table__label'>
                      <div className='value-table__label'>差分</div>
                    </td>
                    <td className='value-table value-table--table__label'>
                      <div className='value-table__label'>主な協力会社</div>
                    </td>
                    <td className='value-table value-table--table__label'>
                      <div className='value-table__label'>主作業</div>
                    </td>
                    <td className='value-table value-table--table__label'>
                      <div className='value-table__label'>人工</div>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {workSummaries.map((workSummary, index) => {
                    return (
                      <tr
                        key={index}
                        className='table__item table__item--admin-operation-list'
                      >
                        <td className='value-table value-table--name'>
                          <div className='value-table__txt--12'>
                            {workSummary.name}
                          </div>
                        </td>
                        <td className='value-table value-table--yotei'>
                          <div className='value-table__normal'>
                            {workSummary.worker
                              ? workSummary.worker.sum_plan
                              : ''}
                          </div>
                        </td>
                        <td className='value-table value-table--jisseki'>
                          <div className='value-table__normal'>
                            {workSummary.worker
                              ? workSummary.worker.sum_result
                              : ''}
                          </div>
                        </td>
                        <td className='value-table value-table--sabun'>
                          <div className='value-table__normal'>
                            <span
                              style={{
                                color:
                                  workSummary.worker &&
                                  workSummary.worker.diff > 0
                                    ? 'red'
                                    : 'black',
                              }}
                              className={
                                workSummary.worker &&
                                workSummary.worker.diff.indexOf('-') >= 0
                                  ? 'required'
                                  : ''
                              }
                            >
                              {workSummary.worker
                                ? workSummary.worker.diff
                                : ''}
                            </span>
                          </div>
                        </td>
                        <td className='value-table value-table--partner-company'>
                          <div className='value-table__normal'>
                            {workSummary.partner
                              ? workSummary.partner.company_partners.map(
                                  (companyPartner, index) => {
                                    return (
                                      <span key={index}>
                                        {companyPartner.name.slice(0, 16)}
                                        <br />
                                      </span>
                                    );
                                  }
                                )
                              : ''}
                          </div>
                        </td>
                        <td className='value-table value-table--main-work'>
                          <div className='value-table__txt--12'>
                            {workSummary.partner
                              ? workSummary.partner.contents
                              : ''}
                          </div>
                        </td>
                        <td className='value-table value-table--jinkou'>
                          <div className='value-table__normal'>
                            {workSummary.partner
                              ? workSummary.partner.work_dayworkers.map(
                                  (workDayworkers, index) => {
                                    return (
                                      <span key={index}>
                                        {workDayworkers.dayworker}
                                        <br />
                                      </span>
                                    );
                                  }
                                )
                              : ''}
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <InfinityScrollLoad
                targetId='infinityscroll-target'
                total={_.size(workSummaries)}
                isLoading={this.state.isLoading}
                callback={notifyEnd => {
                  this.setWorkSummaries(notifyEnd);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FieldWorkSummaries.jsx